import script from "./TeamSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamSection.vue?vue&type=script&setup=true&lang=js"

import "./TeamSection.vue?vue&type=style&index=0&id=5edca9b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5edca9b0"]])

export default __exports__